import * as React from 'react';
import { classes, style } from 'typestyle';
import { regularStyle } from '../../styles/text';
import { disabledStyle } from './Input';
import { Blood, Blue } from '../../styles/colors';
class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (e) => {
            const text = e.target.value;
            this.props.onChange(text);
        };
    }
    render() {
        const { className, disabled, isInvalid, placeholder, readonly, value, rows = 1, onBlur, onFocus, tabIndex, } = this.props;
        return (React.createElement("textarea", { rows: rows, className: classes('ta-atom-textarea', textAreaStyle, className, regularStyle, disabled && disabledStyle, isInvalid && errorStyle), onFocus: onFocus, onBlur: onBlur, onChange: this.handleChange, value: value, placeholder: placeholder, disabled: disabled, readOnly: readonly, tabIndex: tabIndex }));
    }
}
const minHeight = 54;
const textAreaStyle = style({
    resize: 'none',
    overflow: 'auto',
    minHeight,
    height: 'auto',
    outline: 'none',
    padding: 0,
    $nest: {
        '&::placeholder': {
            color: Blue,
        },
    },
});
const errorStyle = style({
    color: `${Blood} !important`,
    $nest: {
        '&::placeholder': {
            color: `${Blood} !important`,
        },
    },
});
export default TextArea;
//# sourceMappingURL=TextArea.js.map